import React, { useState, useRef } from "react";
import styles from "../Styles/EditTemplate.module.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {useUser} from '@clerk/clerk-react';

const EditTemplate = () => {
  const {user}=useUser();
  const [resumeData, setResumeData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    summary: "",
    skills: [],
    languages: "",
  });

  const [newSkill, setNewSkill] = useState("");
  const [showInput, setShowInput] = useState(false);

  const rightSectionRef = useRef(); // Reference to the right section

  const handleChange = (e) => {
    const { name, value } = e.target;
    setResumeData({ ...resumeData, [name]: value });
  };

  const addSkill = () => {
    if (newSkill.trim() !== "") {
      setResumeData({ ...resumeData, skills: [...resumeData.skills, newSkill] });
      setNewSkill("");
      setShowInput(false);
    }
  };

  const removeSkill = (index) => {
    setResumeData({ ...resumeData, skills: resumeData.skills.filter((_, i) => i !== index) });
  };

  // Function to Download PDF
  const downloadPDF = () => {
    const input = rightSectionRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let position = 10;
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      pdf.save("Resume.pdf");
    });
  };

  return (
    <>
    <h1>Welcome {user.fullName}</h1> 
    <div className={styles.container}>
      <div className={styles.leftsection}>
        <h4>Personal Details</h4>
        <div className={styles.grid_container}>
          <input type="text" name="fullName" placeholder="Full Name" onChange={handleChange} value={resumeData.fullName} />
          <input type="email" name="email" placeholder="Email" onChange={handleChange} value={resumeData.email} />
          <input type="text" name="phone" placeholder="Phone Number" onChange={handleChange} value={resumeData.phone} />
          <input type="text" name="city" placeholder="City" onChange={handleChange} value={resumeData.city} />
          <input type="text" name="languages" placeholder="Languages" onChange={handleChange} value={resumeData.languages} />
        </div>

        <h4>Skills:</h4>
        <div className={styles.skillsContainer}>
          {resumeData.skills.map((skill, index) => (
            <div key={index} className={styles.skillBox}>
              {skill} <FontAwesomeIcon icon={faTimes} className={styles.removeIcon} onClick={() => removeSkill(index)} />
            </div>
          ))}

          {showInput ? (
            <div className={styles.inputWrapper}>
              <input 
                type="text" 
                value={newSkill} 
                onChange={(e) => setNewSkill(e.target.value)} 
                placeholder="Enter skill" 
              />
              <FontAwesomeIcon icon={faCheck} className={styles.checkIcon} onClick={addSkill} />
            </div>
          ) : (
            <button className={styles.addSkillButton} onClick={() => setShowInput(true)}>
              <FontAwesomeIcon icon={faPlus} /> Add Skill
            </button>
          )}
        </div>

        <h4>Professional Details</h4>

<textarea name="summary" placeholder="Professional Summary" onChange={handleChange} value={resumeData.summary}></textarea>
      </div>

      {/* Right Section - Resume Preview */}
      <div className={styles.rightsection} ref={rightSectionRef}>
        <h2>{resumeData.fullName}</h2>
        <p><strong>Email:</strong> {resumeData.email}</p>
        <p><strong>Phone:</strong> {resumeData.phone}</p>
        <p><strong>City:</strong> {resumeData.city}</p>
        <p><strong>Summary:</strong> {resumeData.summary}</p>

        <h4>Skills:</h4>
        <div className={styles.skillsPreview}>
          {resumeData.skills.map((skill, index) => (
            <span key={index} className={styles.skillPreviewBox}>{skill}</span>
          ))}
        </div>

        <p><strong>Languages:</strong> {resumeData.languages}</p>
        
        <button onClick={downloadPDF} className={styles.button1}>Download PDF</button>
      </div>

    </div>
    </>
  );
};

export default EditTemplate;
